import { render } from "./dondeycuando.vue?vue&type=template&id=f1980860&scoped=true"
import script from "./dondeycuando.vue?vue&type=script&lang=js"
export * from "./dondeycuando.vue?vue&type=script&lang=js"

import "./dondeycuando.vue?vue&type=style&index=0&id=f1980860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1980860"]])

export default __exports__